import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generateListaDeTiposDeInforme } from '../../Routes/listaDeInformes';
 
export interface ReportType {
  nombre: string;
  informe: string;
  path: string;
  seccion: string; 
  component: string; 
}


interface TypesOfReportsState {
  listaDeTiposDeInforme: ReportType[]; 
}

const initialState: TypesOfReportsState = {
  listaDeTiposDeInforme: generateListaDeTiposDeInforme(), 
};

const typesOfReportsSlice = createSlice({
  name: 'typesOfReports',
  initialState,
  reducers: {
    setListaDeTiposDeInforme: (state, action: PayloadAction<ReportType[]>) => {
      state.listaDeTiposDeInforme = action.payload;
    },
  },
});

export const { setListaDeTiposDeInforme } = typesOfReportsSlice.actions;
export default typesOfReportsSlice.reducer;
